// extracted by mini-css-extract-plugin
export default {"addPromotionContainer":"style_addPromotionContainer__AzgMQ"};